module.exports = __webpack_public_path__ + "img/new_logo_big.6de3ad2e.png";